/**
 * Themes and Variants Constants
 * Contains UI themes, variants, and badge status constants
 */

export enum Themes {
  Dark = 'dark',
  Light = 'light',
}

export enum USER_MODAL_CARD_VARIANT {
  Default = 'default',
  TypeFirst = 'type-first',
  TypeFirstSmall = 'type-first-small',
}

export enum INFORMATIVE_CARD_VARIANT {
  Default = 'default',
  PurpleGradient = 'purple-gradient',
}

export enum BadgeStatus {
  NOT_STARTED = 'Pendiente',
  FINALIZED = 'Completado',
  IN_PROGRESS = 'En curso',
}
